import ButtonBase from "@mui/material/ButtonBase";
import { styled } from "@mui/system";

export const Root = styled("div")({
  width: "55%"
});

export const ImageButtonBase = styled(ButtonBase)(({ theme }) => ({
  position: "relative",
  width: "20%",
  height: 100,
  paddingTop: "20%",
  marginLeft: "10%",
  marginBottom: "15%",
  borderRadius: "15px",
  [theme.breakpoints.down("sm")]: {
    width: "100% !important", // Overrides inline-style
    height: 100
  },
  "&:hover, &$focusVisible": {
    zIndex: 1,
    "& $imageBackdrop": {
      opacity: 0.15
    },
    "& $imageMarked": {
      opacity: 0
    },
    "& $orgTitle": {
      opacity: 1
    }
  }
}));
